// An icon for each stop on the path, from the section's name. Phrasebooks name
// their sections freely, so anything unrecognised just gets a pin - the icon
// is decoration, the section name is the label.
const ICONS = [
  [/basic|greet/i, "👋"],
  [/sign/i, "🪧"],
  [/emergenc|problem|help/i, "🆘"],
  [/medic|symptom|allerg|body|health|doctor/i, "🩺"],
  [/number|count/i, "🔢"],
  [/clock|time|duration|day|week|month|season|date|calendar/i, "🕒"],
  [/weather/i, "⛅"],
  [/colou?r/i, "🎨"],
  [/plane|air/i, "✈️"],
  [/bus|train|transport|travel/i, "🚆"],
  [/boat|ferry/i, "⛴️"],
  [/taxi/i, "🚕"],
  [/direction|map|way/i, "🧭"],
  [/lodg|hotel|accommod|room/i, "🏨"],
  [/money|bank|pay/i, "💱"],
  [/eat|food|restaurant|meal|menu/i, "🍽️"],
  [/bar|drink|sake|wine|beer|tea|coffee/i, "🍺"],
  [/shop|market|buy/i, "🛍️"],
  [/driv|car\b|road/i, "🚗"],
  [/author|police|law/i, "👮"],
  [/phone|call|internet/i, "📞"],
  [/family|people/i, "👪"],
  [/country|countries|territor|nation/i, "🌍"],
  [/safari|animal/i, "🦁"],
  [/church|religio|temple|mosque/i, "🛕"],
  [/learn|grammar|polite|expression|word/i, "💬"],
];

export function stopIcon(section) {
  const match = ICONS.find(([pattern]) => pattern.test(section || ""));
  return match ? match[1] : "📍";
}
